// extracted by mini-css-extract-plugin
export default {"header":"Header_header__c5nVa","langswitcher":"Header_langswitcher__o5ocr","nnLogo":"Header_nnLogo__a0vOI"};